// extracted by mini-css-extract-plugin
export default {"padding_work_p":"our_work_padding_work_p__52wjT","comm_research_butt":"our_work_comm_research_butt__PbPwQ"};